import {useConfirmation} from '../../ConfirmationContext.jsx';
import Dialog from './Dialog.jsx';
import Message from './Message.jsx';

// TODO: if we like this, refactor other calls to ConfirmDialog to use it...
export default function UIConfirmDialog() {
  const {
    isConfirmDialogOpen,
    confirmDialogConfig,
    handleCancelConfirmDialog,
    handleAcceptConfirmDialog,
  } = useConfirmation();

  const variant = confirmDialogConfig?.variant || 'warning';
  const title = confirmDialogConfig?.title || 'Are you sure?';
  const confirmButtonText = confirmDialogConfig?.confirmButtonText || 'Confirm';
  const message = confirmDialogConfig?.message;
  const description = confirmDialogConfig?.description;

  return (
    <Dialog isOpen={isConfirmDialogOpen} onClose={handleCancelConfirmDialog} title={title}>
      {message && (
        <Message variant={variant} className="shadow-sm">
          {message}
        </Message>
      )}

      {description && <p className="text-sm">{description}</p>}

      <div className="flex items-center justify-end space-x-3">
        <button onClick={handleCancelConfirmDialog} className="btn btn-primary btn-ghost">
          Cancel
        </button>

        <button className="btn btn-primary" onClick={handleAcceptConfirmDialog}>
          {confirmButtonText}
        </button>
      </div>
    </Dialog>
  );
}
